import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { Link as RouterLink} from 'react-router-dom';
import { animateScroll as scroll } from "react-scroll";
import {constants} from "../core/data/constants";
import DarkLogo from "../core/assets/img/logoDark.png"
import LightLogo from "../core/assets/img/logoLight.png"


const Footer = ({ theme }) => {
  const startYear = 2024; // The year you started or plan to start
  const currentYear = new Date().getFullYear(); // Gets the current year
  const logoSrc = theme === "dark" ? DarkLogo : LightLogo;
  const websiteName = constants[0].websiteName 
  const logoSite = `Logo de ${websiteName}`

  const copyrightText = startYear === currentYear 
      ? `${currentYear}` 
      : `${startYear}-${currentYear}`;

    
    const socialMediaLinks = constants[0].socialMedia.map((item, index) => {
        let icon;
        switch (item[0]) {
          case 'Facebook':
            icon = faFacebook;
            break;
          case 'TikTok':
            icon = faTiktok;
            break;
          default:
            // Use a default icon or handle other social media platforms as needed
            break;
        }
    
        return (
          <a
            key={index}
            className="hover:text-darkaccent transition-all cursor-pointer"
            href={item[2]}
            target="_blank"
          >
            {icon && <FontAwesomeIcon icon={icon} />}
            {" "}{item[1]}
          </a>
        );
      });

      function formatPhoneNumber(phoneNumber) {
        // Remove any non-digit characters from the phone number
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
      
        // Check if the cleaned phone number has 10 or more digits
        if (cleanedPhoneNumber.length >= 10) {
          return `+${cleanedPhoneNumber.slice(0, 2)} (${cleanedPhoneNumber.slice(2, 5)}) ${cleanedPhoneNumber.slice(5, 8)} ${cleanedPhoneNumber.slice(8)}`;
        } else {
          return phoneNumber; // Return the original number if it doesn't have enough digits to format
        }
      }

      const contactLinks = constants[0].contactNumbers.map((item, index) => (
        <a
          key={index}
          className="hover:text-darkaccent transition-all cursor-pointer"
          href={`https://wa.me/${item[0]}`}
          target="_blank"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
          {" "}{formatPhoneNumber(item[0])}
        </a>
      ));

        const openingHoursItems = constants[0].openingHours.map((item, index) => (
          <div key={index} className="flex justify-between items-center gap-5 border-b">
            <h3>{item[0]}</h3>
            <h3 className="font-light text-darkaccent">{item[1]}</h3>
          </div>
        ));

   
        return (
          <div className=" text-black dark:text-white duration-200 mt-auto flex flex-col items-center">
            <div className="flex flex-col lg:flex-row justify-center lg:w-2/3 w-full">
              <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mb-1 sm:mb-0">
                <img className="h-16" src={logoSrc} alt={logoSite} title={logoSite} loading="lazy" />
              </div>
      
              <div className="py-2 flex flex-col text-center items-center w-full">
                <div className="flex flex-row items-center gap-4">
                  <RouterLink to={'/aviso-de-privacidad'} onClick={scroll.scrollToTop} className="hover:text-darkaccent">
                    Aviso de Privacidad
                  </RouterLink>
                  <RouterLink to={'/terminos-y-condiciones'} onClick={scroll.scrollToTop} className="hover:text-darkaccent">
                    Términos y Condiciones
                  </RouterLink>
                </div>
      
                <p className="text-center py-1">© {copyrightText} Flaco Digital | Derechos Reservados. </p>
              </div>
      
              <div className="w-full lg:w-1/3"></div>
            </div>
          </div>
      );
      
};

export default Footer;